import { render, staticRenderFns } from "./paginations.vue?vue&type=template&id=edbeb5ba&scoped=true&"
import script from "./paginations.vue?vue&type=script&lang=js&"
export * from "./paginations.vue?vue&type=script&lang=js&"
import style0 from "./paginations.vue?vue&type=style&index=0&id=edbeb5ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbeb5ba",
  null
  
)

export default component.exports